<template>
  <div>
    <div class="slider">
      <div class="container">
        <div class="callbacks_container">
          <swiper :options="swiperOption" class="swiper_Content" v-if="bannerList.length > 0">
            <swiper-slide v-for="item of bannerList" :key="item.id" class="rslides" id="slider3">
              <img :src="application.imageHost + item.imagePath" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>

    <!-- 公司介绍-->
    <div class="about">
      <div class="container">
        <Title :title="companyTitle"></Title>
        <companyIntro :hideTitle="true"></companyIntro>
      </div>
    </div>

    <!-- 产品介绍-->
    <div class="blog">
      <div class="container">
        <Title :title="productTitle"></Title>
        <productIntro :pageSize="productPageSize" :pageDefaltIndex="productPageIndex"></productIntro>
        <MoreList :name="moreProduct" :url="productListUrl"></MoreList>
        <!--        <p class="heading-btm-w3ls"></p>-->
      </div>

      <!--      <div class="clearfix"></div>-->
    </div>

    <!--    新闻资讯-->
    <div class="news">
      <div class="container">
        <Title :title="newsTitle"></Title>
        <news :pageSize="newsPageSize" :pageIndex="newsIndex"></news>
        <MoreList :name="moreNews" :url="newsListUrl"></MoreList>
      </div>
    </div>
    <!--// blog -->
    <!--footer-->
    <div class="contact-agile" id="contact">
      <div class="container">
        <!--        <h3 class="tittle">联系我们</h3>-->
        <Title :title="contactUsTitle"></Title>
        <p class="heading-btm-w3ls"></p>
        <ContactUs></ContactUs>
        <!--<p class="heading-btm-w3ls">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
      </div>
      <!--      <div class="map-w3ls">-->
      <!--<iframe src=""></iframe>-->
    </div>
  </div>
</template>
<style src="./index.css" scoped></style>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Header from "../../components/header/header.vue";
import Title from "../../components/title/title";
import companyIntro from "../../components/homeCompanyIntro/homeCompanyIntro";
import productIntro from "../../components/productIntro/productIntro";
import news from "../../components/news/news";
import MoreList from "../../components/moreList/moreList";
import ContactUs from "../../components/contactUs/contactUs";
import mixins from "../../common/mixin";
import application from "../../common/application";

export default {
  name: "index",
  components: {
    Header,
    Title,
    companyIntro,
    productIntro,
    news,
    MoreList,
    ContactUs,
    swiper,
    swiperSlide,
  },
  mixins: [mixins],
  data: () => ({
    companyTitle: "公司介绍",
    productTitle: "主营业务",
    newsTitle: "新闻资讯",
    moreProduct: "更多业务",
    productListUrl: "/product",
    moreNews: "更多新闻",
    newsListUrl: "/newsPage",
    contactUsTitle: "联系我们",
    bannerList: [],
    application: application,
    newsPageSize: 3,
    newsIndex: 1,
    productPageSize: 2,
    productPageIndex: 1,
    swiperOption: {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInterRaction: false,
      },
      loop: true,
    },
  }),
  created() {
    // this.handleCreate();
  },
  mounted() {
    this.handleBannerList();
  },
  methods: {
    //获取轮播图列表
    handleBannerList: function () {
      let data = {
        pageIndex: 0,
        pageSize: 13,
        type: "index",
      };

      this.request({
        url: "/web/banner/list",
        data: data,
        success: (response) => {
          this.bannerList = response.data.records;
          // console.log(this.bannerList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
    // 轮播图
    // handleCreate(){
    //     $(function () {
    //         // Slideshow 3
    //         $("#slider3").responsiveSlides({
    //             initialSlide :0,
    //             observer:true,//修改swiper自己或子元素时，自动初始化swiper
    //             observeParents:true,//修改swiper的父元素时，自动初始化swiper
    //             auto: true,
    //             pager: true,
    //             nav: true,
    //             speed: 500,
    //             namespace: "callbacks",
    //             controls: false,//隐藏左右按钮
    //             before: function () {
    //                 $('.events').append("<li>before event fired.</li>");
    //             },
    //             after: function () {
    //                 $('.events').append("<li>after event fired.</li>");
    //             }
    //         });
    //         $(document).ready(function () {
    //             /*
    //                       var defaults = {
    //                       containerID: 'toTop', // fading element id
    //                       containerHoverID: 'toTopHover', // fading element hover id
    //                       scrollSpeed: 1200,
    //                       easingType: 'linear'
    //                       };
    //                   */
    //             $().UItoTop({
    //                 easingType: 'easeOutQuart'
    //             });
    //         });
    //
    //
    //     });
    // }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue